import { render } from "./MicrosoftTeamsIcon.vue?vue&type=template&id=1bfe8248"
import script from "./MicrosoftTeamsIcon.vue?vue&type=script&lang=js"
export * from "./MicrosoftTeamsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script